import React from "react";
import { Link } from "react-router-dom";
import IndianCoupleVector from "../../images/indian-couple.png";
import shape from "../../images/couple/couple-shape2.png";
import { connect } from "react-redux";
import Hashtag from "../Hashtag/Hashtag";
import { capitalize } from "@mui/material";
import CoupleHeading from "../CoupleHeading/CoupleHeading";
import { Slide } from "react-awesome-reveal";
import CoupleInfo from "../CoupleInfo/CoupleInfo";

const CoupleIndian = ({ bride = {}, groom = {}, isFromPortfolio = false }) => {
  return (
    <Slide
      direction="up"
      delay={100} // Wait before starting
      duration={1000}
      triggerOnce
    >
      <section className="wpo-couple-section-s6 section-padding" id="couple">
        <div className="container">
          <CoupleHeading />
          <Hashtag />
          <div className="couple-area clearfix">
            <div className="row align-items-center">
              <div className="col col-xl-3 col-lg-4 col-12">
                <div className="text-grid">
                  <CoupleInfo data={bride} isGroom={false} />
                </div>
              </div>
              <div className="col col-xl-6 col-lg-4 col-12">
                <div className="middle-couple-pic-wrap zIndex">
                  <div className="middle-couple-pic">
                    <div className="middle-couple-pic-inner">
                      <img src={IndianCoupleVector} alt="" />
                    </div>
                    <div className="couple-shape">
                      <img src={shape} alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col col-xl-3 col-lg-4 col-12">
                <div className="text-grid">
                  <CoupleInfo data={groom} isGroom={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Slide>
  );
};

const mapStateToProps = (state) => {
  return {
    groom: state.inviteDetails.invite?.groom,
    bride: state.inviteDetails.invite?.bride,
    hashtag: state.inviteDetails.invite?.hashtag,
    isFromPortfolio: state.common?.isFromPortfolio,
  };
};

export default connect(mapStateToProps)(CoupleIndian);
